<template>
  <div class="row">
    <h1>Charge <span v-if="batchId" class="key heavy">{{ batch.uniqueNumber + (batch.number ? '/'+ batch.number : '') }}</span></h1>
    <ul class="output col-8 mb-0">
      <li><label class="col-2">Lieferant</label> {{ supplierName }}</li>
      <li><label class="col-2">Produkt</label> {{ productName }}</li>
      <li v-if="batch.productId == 1 && batch.qualityStandard"><label class="col-2">Standard</label> {{ batch.qualityStandard }}</li>
      <li v-if="batch.breed"><label class="col-2">Sorte</label> {{ batch.breed }}</li>
      <li><label class="col-2">Aufkäufer</label> {{ regraterName }}</li>
      <li v-if="batch.lane"><label class="col-2">Gasse</label> {{ batch.lane }}</li>
      <li v-if="parseInt(batch.washedWeight) > 0"><label class="col-2">Nass</label> {{ globalFunctions.parseNumber(batch.washedWeight) }} kg
      </li>
      <li v-if="batch.washedQuality"><label class="col-2">Qualität</label> {{ batch.washedQuality }}</li>
      <li v-if="batch.washedPicture1"><label class="col-2">Foto</label> <img :src="batch.washedPicture1"
                                                                             style="max-width: 60%;max-height: 300px"/>
      </li>
    </ul>
    <div class="w-100 mb-3">
      <button v-if="canWrite && !batch.driedWeight" @click="editBatch(batch)" class="edit">~</button>
      <div v-if="batchId" class="col-8 text-right">
        <api-pdf-link method="batchslip" :elementId="batch.uniqueId" class="float-right"/>
      </div>
    </div>
  </div>

  <div v-if="hasImages" class="row">
    <details
        class="output col-8">
      <summary><h2>Bilder</h2></summary>
      <div class="row">
      <div v-for="image in images" :key="image.imageId" class="col-8 col-md-4 col-lg-3">
        <figure>
          <figcaption>{{ getWorkflowLabel(image.workflowState) }}{{ dryersAmount > 1 && image.dryerId > 0 ? ': '+ getDryerLabel(image.dryerId) : ''}}</figcaption>
          <img :src="image.picture" :alt="image.imageId" style="max-width:100%"/>
        </figure>
      </div>
      </div>
    </details>
  </div>

  <div v-if="hasComments" class="row">
    <details
        class="output col-8">
      <summary><h2>Notizen</h2></summary>
      <div v-for="comment in comments" :key="comment.commentId" class="output col-8">
        <label>{{ getWorkflowLabel(comment.workflowState) }}</label><br/><p>{{ comment.comment }}</p>
      </div>
    </details>
  </div>


  <div v-if="batch.driedWeight > 0" class="row">
    <h2>Getrocknet</h2>
    <ul class="output col-8 mb-0">
      <li v-if="batch.driedWeight"><label class="col-3">Trocken</label>
        {{ globalFunctions.parseNumber(batch.driedWeight) }} kg</li>
      <li v-if="batch.driedMoisture > 0"><label class="col-3">Feuchte</label> {{ batch.driedMoisture }} %</li>
      <li v-if="batch.driedHlWeight > 0"><label class="col-3">HL-Gewicht</label> {{ batch.driedHlWeight }} kg</li>
    </ul>
  </div>
  <div v-if="batch.workflowState > 10 && (batch.tareWeight > 0 || batch.sampleNumber)"
       class="row mb-3">
    <h2>Eingang</h2>
    <ul class="output col-8 mb-0">
      <li v-if="batch.grossWeight"><label class="col-3">Brutto-Gewicht</label>
        {{ globalFunctions.parseNumber(batch.grossWeight) }} kg</li>
      <li v-if="batch.tareWeight"><label class="col-3">Tara-Gewicht</label>
        {{ globalFunctions.parseNumber(batch.tareWeight) }} kg</li>
      <li v-if="batch.dockage > 0"><label class="col-3">Besatz</label>
        {{ globalFunctions.parseNumber(batch.dockage) }} %</li>
      <li v-if="batch.protein > 0"><label class="col-3">Protein</label>
        {{ globalFunctions.parseNumber(batch.protein) }} %</li>
      <li v-if="batch.sampleNumber"><label class="col-3">Probe Nr</label> {{ batch.sampleNumber }}</li>
      <li v-if="batch.dockage > 0"><label class="col-3">- Besatz</label>
        {{ globalFunctions.parseNumber(batch.tareWeight - (batch.tareWeight * batch.dockage / 100)) }} kg</li>
    </ul>
  </div>
</template>

<script>
import ApiPdfLink from "@/components/ApiPdfLink.vue";
import { inject } from 'vue'

export default {
  name: "BatchHeader",
  components: {ApiPdfLink},
  data() {
    return {
      globalFunctions: inject('globalFunctions'),
      images: [],
      comments: [],
    }
  },
  props: {
    batch: Object,
    batchId: Number,
    canWrite: Boolean,
    supplierName: String,
    regraterName: String,
    productName: String,
    refreshNotes: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    await this.loadNotes()
  },
  computed: {
    hasImages() {
      return this.images && this.images.length > 0
    },
    hasComments() {
      return this.comments && this.comments.length > 0
    },
    dryers() {
      return this.$store.getters.dryers
    },
    dryersAmount() {
      return this.$store.getters.dryersAmount
    },
  },
  emits: ['editBatch', 'refreshed'],
  methods: {
    editBatch(batch) {
      this.$emit('editBatch', batch)
    },
    getWorkflowLabel(workflowState) {
      switch (workflowState) {
        case 10: return 'Eingang'
        case 20: return 'Waschen'
        case 30: return 'Trocknen'
        case 40: return 'Reinigung'
      }
    },
    getDryerLabel(dryerId) {
      return this.dryers[dryerId]
    },
    async loadNotes() {
      this.images = await this.$store.dispatch('getItemsByParent', {
        entityName: 'image',
        parentEntity: 'batch',
        parentId: this.batchId,
        returnData: true,
      })
      this.comments = await this.$store.dispatch('getItemsByParent', {
        entityName: 'comment',
        parentEntity: 'batch',
        parentId: this.batchId,
        returnData: true,
      })
      this.$emit('refreshed', {what: 'notes'})
    },
  },
  watch: {
    refreshNotes(newVal) {
      if (newVal) this.loadNotes()
    },
  }
}
</script>